import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const isAuthenticated = authService.isAuthenticated();
  const accountType = authService.getAccountType();

  if (!isAuthenticated) return true;

  return accountType === 'ADMIN'
    ? router.createUrlTree(['/admin'])
    : router.createUrlTree(['/user']);
};